import React from 'react';
import {RadioButton} from 'material-ui/RadioButton';
import classNames from 'classnames';

export default class RadioField extends React.PureComponent {
  render() {
    return (
      <div className={classNames(this.props.className, 'ev-radio-field')}>
        <RadioButton {...this.props} />
      </div>
    );
  }
}
